import React, { useEffect, type ReactNode } from 'react';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { ServiceDeskAnalyticsContext } from '@atlassian/jira-servicedesk-analytics/src/ui/servicedesk-analytics-context/index.tsx';

const FireViewedEvent = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	useEffect(() => {
		fireUIAnalytics(createAnalyticsEvent({}), 'menuItem viewed', 'journeysNav');
	}, [createAnalyticsEvent]);
	return null;
};

export const JourneyNavItemWrapper = ({ children }: { children: ReactNode }) => {
	return (
		<ServiceDeskAnalyticsContext>
			{children}
			<FireViewedEvent />
		</ServiceDeskAnalyticsContext>
	);
};
